module.exports = function() {
  return new Worker(__webpack_public_path__ + "1bbec43fd7dcd7f715e7.worker.js");
};